"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _guacWidgetCore = require("@wsb/guac-widget-core");

var _BookingDetailsContent = _interopRequireDefault(require("./BookingDetailsContent"));

var _ResourceHelper = _interopRequireDefault(require("../../utils/ResourceHelper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var BookingResourceDetails = function BookingResourceDetails(_ref) {
  var resources = _ref.resources,
      i18n = _ref.i18n;
  var Details = _guacWidgetCore.UX2.Element.Details;
  return /*#__PURE__*/_react["default"].createElement(_BookingDetailsContent["default"], {
    icon: "person",
    title: i18n.resourceLabel
  }, /*#__PURE__*/_react["default"].createElement(Details, null, _ResourceHelper["default"].getName(resources[0], {
    ownerResourceName: i18n.businessOwner
  })));
};

BookingResourceDetails.propTypes = {
  resources: _propTypes["default"].arrayOf(_propTypes["default"].object.isRequired).isRequired,
  i18n: _propTypes["default"].shape({
    resourceLabel: _propTypes["default"].string.isRequired,
    businessOwner: _propTypes["default"].string.isRequired
  }).isRequired
};
var _default = BookingResourceDetails;
exports["default"] = _default;